// Utilities/apiConfig.js
// const ROOT_URL = "https://inwiton.com";
// const ROOT_URL = "https://columbiaa-backend.onrender.com";
const ROOT_URL = "https://columbiaabackend.onrender.com";
// (nsmshd02)
// const ROOT_URL = "https://columbiaabackend-f2vs.onrender.com";
// (nsmshd0)
// const ROOT_URL = "http://192.168.0.196:5000";

export default ROOT_URL;
